
export const RegExpr = {
	getfilter:
		"'|(and|or)\\b.+?(>|<|=|in|like)|\\/\\*.+?\\*\\/|<\\s*script\\b|\\bEXEC\\b|UNION.+?SELECT|UPDATE.+?SET|INSERT\\s+INTO.+?VALUES|(SELECT|DELETE).+?FROM|(CREATE|ALTER|DROP|TRUNCATE)\\s+(TABLE|DATABASE)",
	postfilter:
		"\\b(and|or)\\b.{1,6}?(=|>|<|\\bin\\b|\\blike\\b)|\\/\\*.+?\\*\\/|<\\s*script\\b|\\bEXEC\\b|UNION.+?SELECT|UPDATE.+?SET|INSERT\\s+INTO.+?VALUES|(SELECT|DELETE).+?FROM|(CREATE|ALTER|DROP|TRUNCATE)\\s+(TABLE|DATABASE)",
	cookiefilter:
		"\\b(and|or)\\b.{1,6}?(=|>|<|\\bin\\b|\\blike\\b)|\\/\\*.+?\\*\\/|<\\s*script\\b|\\bEXEC\\b|UNION.+?SELECT|UPDATE.+?SET|INSERT\\s+INTO.+?VALUES|(SELECT|DELETE).+?FROM|(CREATE|ALTER|DROP|TRUNCATE)\\s+(TABLE|DATABASE)",
	mobilePhone: /^[1][0-9][0-9]\d{8}$/i,
	// 'url': /^((http|https|ftp|vm):\/\/)/i,
	url: /http[s]?:\/\/(?:(?!http[s]?:\/\/)[a-zA-Z]|[0-9]|[$\-_@.&+/]|[!*(),]|(?:%[0-9a-fA-F][0-9a-fA-F]))+/gi,
	base64: /[^a-zA-Z0-9/+=]/i,
	idcard: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
	ip: /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})$/i,
	email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}$/i,
	numeric: /^[0-9]+(.[0-9]{1,20})?$/,
	numberReg: /^([1-9]\d*|[0]{1,1})$/, // 数字校验，含0的正整数
	fax: /^(\d{3,4}-)?\d{7,8}$/,
	integer: /^-?[0-9]+$/,
	html: /<[^> ]+>/gi,
	//https://blog.csdn.net/wmx690/article/details/80354321
	//支持格式示例-固话：+86-010-40020020，010-40020020 国家代码选填；手机：+86-10-13523458056,  +86-13523458056 ，10-13523458056 ，13523458056 国家代码和区号选填
	//REGEX_TEL : /^(((\+\d{2}-)?0\d{2,3}-\d{7,8})|((\+\d{2}-)?(\d{2,3}-)?([1][3,4,5,7,8][0-9]\d{8})))$/,
	//"telephone": /^(((\+\d{2}-)?0\d{2,3}-\d{7,8})|((\+\d{2}-)?(\d{2,3}-)?([1][3,4,5,7,8][0-9]\d{8})))$/,
	//修改：使固化可以省略区号
	telephone: /^(((\+\d{2}-)?(0\d{2,3}-)?\d{7,8})|((\+\d{2}-)?(\d{2,3}-)?([1][0-9][0-9]\d{8})))$/,
	variable: /^[a-zA-Z_][a-zA-Z0-9_]+$/, //编号规则 只能包含字母数字下划线，且不能数字开头
	chinese: /[\u4E00-\u9FFF]|[\uFE30-\uFFA0]/, //包含汉字
	longitude: /^(0?\d{1,2}\.\d{1,5}|1[0-7]?\d{1}\.\d{1,5}|180\.0{1,5})$/,
	latitude: /^([0-8]?\d{1}\.\d{1,5}|90\.0{1,5})$/
}

export const _re_escape_regex = new RegExp(
	"(\\" +
		[
			"/",
			".",
			"*",
			"+",
			"?",
			"|",
			"(",
			")",
			"[",
			"]",
			"{",
			"}",
			"\\",
			"$",
			"^",
			"-"
		].join("|\\") +
		")",
	"g"
)
/**
 * 将一个正则表达式字串转义
 * Escape a string such that it can be used in a regular expression.
 * from https://cdn.datatables.net/v/dt/dt-1.10.18/datatables.js
 * @param {string} val string to escape
 * @returns {string} escaped string
 */
export function escapeRegex (val) {
	return val.replace(_re_escape_regex, "\\$1")
}
const getSafeHTML = require("xss")
export function deepCopy (obj){ //, cache = []) {
	return JSON.parse(JSON.stringify(obj))
}
/**
 * 频率控制 返回函数连续调用时，fn 执行频率限定为每多少时间执行一次
 * @param fn {Function}  需要调用的函数
 * @param delay  {Number}    延迟时间，单位毫秒
 * @param immediate  {Boolean} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
 * @return {Function}实际调用函数
 */
export function throttle (fn, delay, immediate, debounce) {
	let curr = +new Date(), //当前事件
		last_call = 0,
		last_exec = 0,
		timer = null,
		diff, //时间差
		context, //上下文
		args,
		exec = function () {
			last_exec = curr
			fn.apply(context, args)
		}
	return function () {
		curr = +new Date()
		;(context = this),
		(args = arguments),
		(diff = curr - (debounce ? last_call : last_exec) - delay)
		clearTimeout(timer)
		if (debounce) {
			if (immediate) {
				timer = setTimeout(exec, delay)
			} else if (diff >= 0) {
				exec()
			}
		} else {
			if (diff >= 0) {
				exec()
			} else if (immediate) {
				timer = setTimeout(exec, -diff)
			}
		}
		last_call = curr
	}
}

/**
 * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 delay，fn 才会执行
 * @param fn {Function}  要调用的函数
 * @param delay   {Number}    空闲时间
 * @param immediate  {Boolean} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
 * @return {Function}实际调用函数
 */
export function debounce (fn, delay, immediate) {
	return throttle(fn, delay, immediate, true)
}
/**
 * 延时Promise
 * @param {secs} 延时秒数
 * @returns {Promise} 空方法
 * @example
 * const a = 1
 * await util.sleep(2)
 * alert(a)
 */
export function sleep (secs) {
	return new Promise((resolve) => {
		setTimeout(resolve, secs * 1000)
	})
}
/**
 * 过滤非法HTML
 * 与xss不同，只过滤部分危险标签，保留原HTML
 * 文档:https://jsxss.com/zh/index.html
 * @param {String} html 原始HTML
 * @returns {String} 安全的HTML
 */
export function safeHTML (html) {
	return getSafeHTML(html, {
		//					whiteList:          [],        // 白名单为空，表示过滤所有标签
		//					stripIgnoreTag:     true,      // 过滤所有非白名单标签的HTML
		stripIgnoreTagBody: ["script"], //黑名单
		//todo：过滤规则还不太懂，img src为白名单内容，但是默认会过滤掉base64图片
		//按api文档用以下代码解决。有空再仔细研究
		//https://github.com/leizongmin/js-xss/pull/189
		onTagAttr: function (tag, name, value, isWhiteAttr = false) {
			isWhiteAttr
			if (tag === "img" && name === "src") return `src="${value}"`
			if (name === "style") return `style="${value}"`
			return value
		}
	})
}
/**
	* 通用的vue router转换方法。将一个简易路由对象转为vue路由
	* @param  {Object} map 简易路由对象
	* @param  {Function} componentLoader 组件模块加载方法(为了在路由文件使用带上下文的import方法)
	* @returns {Array} Vue Router配置
 * @example
const routeMap = {
	"/ida50": {
		"component": "../baf/Index",
		"children": {
			"openBill": {
				"list": {
					"component": "./openBill/Index",
					"children": {
						"pending": "./openBill/PendingList",
					}
				},
				"detail": "./openBill/Detail",
				"booking": "./openBill/booking/Index",
			},
			"filter": "./filter/filterManager",
			"404": {redirect: "/baf/404"},
			"500": {redirect: "/baf/500"}
		}
	},
	"/filter": "./filter/filterManager"
}
export default util.convertRouteMap(routeMap, function (module){
	if(module.startsWith("../")){
		return import(`../${module.substr(3)}`)
	}
	return import(`${module}`)
})
 */
export function convertRouteMap (map, componentLoader) {
	let routes = []
	const emptyComponent = { template: "<router-view />" }
	Object.keys(map).forEach(key => {
		const module = map[key]
		if (typeof module === "string") {
			routes.push({
				path: key,
				component: () => componentLoader(module)
			})
		}
		if (typeof module !== "object") return false
		if (module.redirect) {
			routes.push({
				path: key,
				redirect: module.redirect
			})
			return false
		}
		if (module.component) {
			let component = null
			component = () => componentLoader(module.component)
			routes.push({
				path: key,
				component,
				children: convertRouteMap(module.children || {}, componentLoader)
			})
			return false
		}
		routes.push({
			path: key,
			component: emptyComponent,
			children: convertRouteMap(module || {}, componentLoader)
		})
	})
	return routes
}
export default {
	safeHTML,
	escapeRegex,
	RegExpr,
	deepCopy,
	sleep,
	throttle,
	debounce,
	convertRouteMap
}
